module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'switch-field': true,
      'switch-field-readonly': _vm.readonly
    }
  }, [_c('label', {
    class: {
      'switch-label': true,
      'switch-label-active': !_vm.loading
    }
  }, [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")]), _vm._v(" "), (!_vm.loading) ? _c('v-switch', {
    staticClass: "switch-input",
    attrs: {
      "label": _vm.text,
      "input-value": _vm.value,
      "disabled": _vm.disabled || _vm.readonly
    },
    on: {
      "change": _vm.changeHandler
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [(_vm.loading) ? _vm._t("progress", [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": _vm.progressColor,
      "width": _vm.progressWidth
    }
  })]) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d488340","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SwitchField.vue
// module id = 12
// module chunks = 0